import { useTranslation } from "react-i18next"

import { CalendarRange, Sparkles } from "@/components/icons"
import { Button } from "@/components/ui/button"
import { Card } from "@/components/ui/card"

type WeeklyHeroProps = {
  mode: "wrap" | "plan"
  onAction?: (mode: "wrap" | "plan") => void
}

export function WeeklyHero({ mode, onAction }: WeeklyHeroProps) {
  const { t } = useTranslation()
  const Icon = mode === "wrap" ? Sparkles : CalendarRange

  const title =
    mode === "wrap"
      ? t("chatHome.weeklyHero.wrapTitle", "Wrap up your week")
      : t("chatHome.weeklyHero.planTitle", "Plan the week ahead")

  const body =
    mode === "wrap"
      ? t(
          "chatHome.weeklyHero.wrapBody",
          "Want a quick recap of what you worked on this week — meetings, edits, sent mail?"
        )
      : t(
          "chatHome.weeklyHero.planBody",
          "Want a heads-up on what's coming up — meetings, deadlines, where to focus?"
        )

  const action =
    mode === "wrap"
      ? t("chatHome.weeklyHero.wrapAction", "Draft my weekly recap →")
      : t("chatHome.weeklyHero.planAction", "Plan my week →")

  return (
    <Card
      className="border-primary/30 bg-primary/5 mx-auto flex w-full max-w-2xl flex-col gap-4 border-2 px-6 py-5 shadow-md"
      data-testid={`weekly-hero-${mode}`}
    >
      <div className="flex items-start gap-3">
        <Icon className="text-primary mt-0.5 size-5 shrink-0" />
        <div className="flex-1 space-y-1">
          <h2 className="text-lg leading-tight font-semibold">{title}</h2>
          <p className="text-foreground/80 text-sm">{body}</p>
        </div>
      </div>
      <div>
        <Button
          data-testid={`weekly-hero-action-${mode}`}
          size="sm"
          onClick={() => onAction?.(mode)}
        >
          {action}
        </Button>
      </div>
    </Card>
  )
}
